module.exports = __webpack_public_path__ + "img/hr-white-desert-bush-08.b31ca633.png";